// extracted by mini-css-extract-plugin
export default {"grouptable":"grouped_grouptable__whIUJ","title":"grouped_title__hL7Y4"};